import { render, staticRenderFns } from "./CompanyDataUpdatePopupDetails.vue?vue&type=template&id=20a946fe&scoped=true&"
import script from "./CompanyDataUpdatePopupDetails.vue?vue&type=script&lang=js&"
export * from "./CompanyDataUpdatePopupDetails.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDataUpdatePopupDetails.vue?vue&type=style&index=0&id=20a946fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a946fe",
  null
  
)

export default component.exports